import { nextTick, reactive } from 'vue'
import { watchDebounced } from '@vueuse/core'

export type PreviewOverflowWatchSource = {
  name: string
  source: () => unknown
}

export function usePreviewOverflow(options: {
  getEl: (name: string) => HTMLElement | undefined
  maxHeights: Record<string, number>
  watchSources?: PreviewOverflowWatchSource[]
}) {
  const classObject = reactive<Record<string, Record<string, boolean>>>({})
  const errorMessages = reactive<Record<string, string>>({})

  function ensureKeys(name: string) {
    if (!(name in classObject)) {
      classObject[name] = {}
    }
    if (!(name in errorMessages)) {
      errorMessages[name] = ''
    }
  }

  for (const name of Object.keys(options.maxHeights)) {
    ensureKeys(name)
  }

  function adjustFontSize(refName: string) {
    ensureKeys(refName)
    classObject[refName] = {}
    errorMessages[refName] = ''
    nextTick(() => {
      const el = options.getEl(refName)
      if (!el) return
      const maxHeight = options.maxHeights[refName]
      if (maxHeight == null) return
      if (el.clientHeight > maxHeight) {
        classObject[refName] = {
          'font-size-sm': true
        }
      } else {
        classObject[refName] = {}
      }
      nextTick(() => {
        if (el.clientHeight > maxHeight) {
          errorMessages[refName] = '入力欄をオーバーしてます'
          classObject[refName] = { 'font-size-sm': true, error: true }
        }
      })
    })
  }

  if (options.watchSources) {
    for (const item of options.watchSources) {
      watchDebounced(
        item.source,
        () => {
          adjustFontSize(item.name)
        },
        { debounce: 500 }
      )
    }
  }

  return {
    classObject,
    errorMessages,
    adjustFontSize
  }
}
